import { graphqlApi } from '@/graphql'
import { baseApi } from '@/services'
import { TitleReport } from '@/types/unlock'

const titleReportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getTitleReport: builder.query<TitleReport, string>({
      query: (titleReportUUID) => ({
        url: `v2/title-reports/${titleReportUUID}/`,
      }),
      providesTags: ['TitleReport'],
    }),
    createTitleReport: builder.mutation<TitleReport, Partial<TitleReport>>({
      query: (titleReport) => ({
        url: 'v2/title-reports/',
        method: 'POST',
        body: titleReport,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'Alert',
        'Property',
      ],
    }),
    updateTitleReport: builder.mutation<TitleReport, Partial<TitleReport>>({
      query: (titleReport) => ({
        url: `v2/title-reports/${titleReport.uuid}/`,
        method: 'PATCH',
        body: titleReport,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'TitleReport',
        'Alert',
        'Property',
      ],
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(graphqlApi.util.invalidateTags(['gql:application']))
      },
    }),
    updateOrCreateTitleReport: builder.mutation<TitleReport, Partial<TitleReport>>({
      query: (titleReport) => {
        const url = titleReport?.uuid
          ? `v2/title-reports/${titleReport.uuid}/`
          : 'v2/title-reports/'
        const method = titleReport?.uuid ? 'PATCH' : 'POST'
        return {
          url,
          method,
          body: titleReport,
        }
      },
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'TitleReport',
        'Alert',
        'Property',
        'PropertyV2',
      ],
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(graphqlApi.util.invalidateTags(['gql:application']))
      },
    }),
  }),
})

export const {
  useGetTitleReportQuery,
  useCreateTitleReportMutation,
  useUpdateTitleReportMutation,
  useUpdateOrCreateTitleReportMutation,
} = titleReportApi
